// The shape created by the text tool
import {TDBaseShape} from '@modules/whiteboard'

export interface TextShape extends TDBaseShape {
  type: 'text'
  text: string
  size: number[]
}

export * from './TextUtil'
export * from './TextShapeComponent'


// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/text/index.ts